import { Component, OnInit } from '@angular/core';
import { MultiDeviceInteractionService } from '../../../services/multi-device-interaction.service';
import { MultiDeviceInteractionModel, MultiDeviceInteractionState, BulkItemOptions, InteractionHowModel, SetBulkFriendlyDisconnect, BulkFriendlyRequest } from '../../../models/consumer/consumer-interaction.model';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ConsumerInteractionService } from '../../../services/consumer-interaction.service';
import { ConsumerBulkInteractionModel } from '../../../models/consumer/consumer-bulk-interaction.model';
import { getParamFromAncestorRoute } from '../../../utilities/route.utilities';
import { BulkCreditInteractionModel } from '../../../models/consumer/bulk-credit-interaction.model';
import { BulkScreenMessageModel } from '../../../models/consumer/bulk-screen-message-model.module';

@Component({
  selector: 'multi-device-summary',
  templateUrl: './multi-device-summary.component.html',
  styles: []
})
export class MultiDeviceSummaryComponent implements OnInit {

    clientId: number;
    interactonData: MultiDeviceInteractionModel;
    friendlyDisconnect: SetBulkFriendlyDisconnect;
    interactionHow: InteractionHowModel;
    friendlySpecialDays: any[] = [];
    bulkState: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private consumerInteractionService: ConsumerInteractionService,
        private multiDeviceInteractionService: MultiDeviceInteractionService
    ) { }

    ngOnInit() {
        this.interactonData = JSON.parse(window.sessionStorage.getItem("multi-device-interaction"));
        this.interactionHow = this.interactonData.how;
        this.setState(this.interactonData.what.type.key);
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
    }

    private redirect(state: MultiDeviceInteractionState) {
        this.router.navigated = false;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { state: state }
        });
    }

    editWhat() {
        this.redirect(MultiDeviceInteractionState.what);
    }

    editWhen() {
        this.redirect(MultiDeviceInteractionState.when);
    }

    editHow() {
        this.redirect(MultiDeviceInteractionState.how);
    }

    editWho() {
        this.redirect(MultiDeviceInteractionState.who);
    }

    abandonRequest() {
        window.sessionStorage.removeItem("multi-device-interaction");
        this.multiDeviceInteractionService.clear();
        this.redirect(MultiDeviceInteractionState.what);
    }

    sendInteractions() {

        if (!this.interactonData) return;

        let bulkCreditStatus = new ConsumerBulkInteractionModel();
        bulkCreditStatus.consumerIds = this.interactonData.who.consumerIds.slice();
        bulkCreditStatus.bulkId = this.interactonData.what.tag;
       
        bulkCreditStatus.scheduleTime = this.interactonData.when.date;
        let bulkItemOption: BulkItemOptions = this.interactonData.what.type.key as BulkItemOptions;

        if (bulkItemOption == BulkItemOptions.GetCreditStatus) {

            this.consumerInteractionService.PostBulkDeviceCreditStatus(this.clientId, bulkCreditStatus).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not get credit status: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.GetConnectionStatus) {
            this.consumerInteractionService.PostBulkConnectionStatus(this.clientId, bulkCreditStatus).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });

            })).catch((error) => {
                console.log("could not get connection status: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.GetSupplyTarrifs) {
            this.consumerInteractionService.PostBulkDeviceTarrif(this.clientId, bulkCreditStatus).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });

            })).catch((error) => {
                console.log("could not get supply tarrifs: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.GetMeterReads) {
            this.consumerInteractionService.PostBulkDeviceMeterRead(this.clientId, bulkCreditStatus).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });

            })).catch((error) => {
                console.log("could not get meter reads: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.GetStandingCharges) {
            this.consumerInteractionService.postBulkStandingCharge(this.clientId, bulkCreditStatus).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not get standing charges: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.GetFriendlyDisconnect) {

           
            this.consumerInteractionService.PostBulkFriendlyDisconnectRequest(this.clientId, bulkCreditStatus).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not get friendly disconnect settings: " + error);
            });
        }

        //Update bulk values
        if (bulkItemOption == BulkItemOptions.UpdateFriendlyDisconnectSettings) {
            this.friendlyDisconnect = this.interactonData.how.friendlyDisconnect;

            let bulkFriendlyRequest = this.GetFriendlyDisconnectRequestModel(this.friendlyDisconnect);

            bulkFriendlyRequest.scheduleTime = this.interactonData.when.date != null ? this.interactonData.when.date : new Date();

            this.consumerInteractionService.PostSetBulkFriendlyDisconnect(this.clientId, bulkFriendlyRequest).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not set bulk friendly disconnect settings: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.ResetCreditStatus) {
            let BulkResetStatus = new BulkCreditInteractionModel();
            BulkResetStatus.consumerIds = this.interactonData.who.consumerIds.slice();
            BulkResetStatus.scheduleTime = this.interactonData.when.date;
            BulkResetStatus.value = 0.00;
            BulkResetStatus.bulkId = this.interactonData.what.tag;

            this.consumerInteractionService.PutBulkDeviceCreditStatus(this.clientId, BulkResetStatus).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not bulk reset credit status: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.AdjustCreditStatus) {

            let adjustBulkCredit = new BulkCreditInteractionModel();
            adjustBulkCredit.consumerIds = this.interactonData.who.consumerIds.slice();
            adjustBulkCredit.scheduleTime = this.interactonData.when.date;
            adjustBulkCredit.value = this.interactonData.how.value;
            adjustBulkCredit.bulkId = this.interactonData.what.tag;

            this.consumerInteractionService.PutBulkDeviceCreditStatus(this.clientId, adjustBulkCredit).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not adjust credit status: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.ChangeECLimit) {

            let bulkECLimit = new BulkCreditInteractionModel();
            bulkECLimit.consumerIds = this.interactonData.who.consumerIds.slice();
            bulkECLimit.scheduleTime = this.interactonData.when.date;
            bulkECLimit.value = this.interactonData.how.value;
            bulkECLimit.bulkId = this.interactonData.what.tag;

            this.consumerInteractionService.PutBulkECLimit(this.clientId, bulkECLimit).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not change bulk ec limit credit status: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.ApplyLoan) {

            let bulkECLimit = new BulkCreditInteractionModel();
            bulkECLimit.consumerIds = this.interactonData.who.consumerIds.slice();
            bulkECLimit.scheduleTime = this.interactonData.when.date;
            bulkECLimit.value = this.interactonData.how.value;
            bulkECLimit.bulkId = this.interactonData.what.tag;

            this.consumerInteractionService.BulkApplyLoan(this.clientId, bulkECLimit).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not apply bulk loan, error: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.UpdateStandingCharges) {
            let bulkECLimit = new BulkCreditInteractionModel();
            bulkECLimit.consumerIds = this.interactonData.who.consumerIds.slice();
            bulkECLimit.scheduleTime = this.interactonData.when.date;
            bulkECLimit.value = this.interactonData.how.value;
            bulkECLimit.bulkId = this.interactonData.what.tag;

            this.consumerInteractionService.setBulkStandingCharges(this.clientId, bulkECLimit).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not set bulk standing charge, error: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.UpdateSupplyTarrifs) {

            let supplyTarrif = new BulkCreditInteractionModel();
            let supplyType: string = this.interactonData.how.supplyTarrifType;

            if (supplyType != "Heat" && supplyType != "Electricity") {
                supplyType = 'Other';
            }

            supplyTarrif.consumerIds = this.interactonData.who.consumerIds.slice();
            supplyTarrif.scheduleTime = this.interactonData.when.date;
            supplyTarrif.value = this.interactonData.how.value;
            supplyTarrif.bulkId = this.interactonData.what.tag;

            this.consumerInteractionService.setBulkSupplyTarrifs(this.clientId,supplyType, supplyTarrif).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not set bulk standing charge, error: " + error);
            });
        }

        if (bulkItemOption == BulkItemOptions.SendScreenMessage) {
            let bulkSendMessage = new BulkScreenMessageModel();
            bulkSendMessage.consumerIds = this.interactonData.who.consumerIds.slice();
            bulkSendMessage.scheduleTime = this.interactonData.when.date;
            bulkSendMessage.message = this.interactonData.how.message;
            bulkSendMessage.bulkId = this.interactonData.what.tag;

            this.consumerInteractionService.PostBulkDeviceScreenMessage(this.clientId, bulkSendMessage).then((bulkVal => {
                this.router.navigate(['../submit'], { relativeTo: this.route });
            })).catch((error) => {
                console.log("could not send bulk send message, error: " + error);
            });
        }
    }

    setState(bulkKey: string) {

        if (bulkKey == BulkItemOptions.AdjustCreditStatus) {
            this.bulkState = "ajustcredit";
        }

        if (bulkKey == BulkItemOptions.ApplyLoan) {
            this.bulkState = "applyloan";
        }

        if (bulkKey == BulkItemOptions.ChangeECLimit) {
            this.bulkState = "changeeclimit";
        }

        if (bulkKey == BulkItemOptions.SendScreenMessage) {
            this.bulkState = "sendscreenmessage";
        }

        if (bulkKey == BulkItemOptions.UpdateFriendlyDisconnectSettings) {
            this.bulkState = "updatefriendlydisconnect";
            this.friendlyDisconnect = this.interactonData.how.friendlyDisconnect;
            this.friendlySpecialDays = this.interactonData.how.friendlyDisconnect.specialDays.filter(x => x.selected == true);
        }

        if (bulkKey == BulkItemOptions.UpdateStandingCharges) {
            this.bulkState = "updatestandingcharges";
        }

        if (bulkKey == BulkItemOptions.UpdateSupplyTarrifs) {
            this.bulkState = "updatesupplytariffs";
        }
    }

    SecondsFromMidnightToTime(seconds: number): string {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        date.setSeconds(date.getSeconds() + seconds);
        let time = date.getHours().toString() + ':' + date.getMinutes().toString() + ':' + date.getSeconds().toString();
        time = this.formatTime24(time);
        return time;
    }

    GetFriendlyDisconnectRequestModel(friendlyDisconnect: SetBulkFriendlyDisconnect): BulkFriendlyRequest {

        let friendlyDisconnectRequest: BulkFriendlyRequest;
        let getSecondsFromMidnight = (time) => {
            let seconds = 0;
            seconds += time.split(':')[0] * 60 * 60;
            seconds += time.split(':')[1] * 60;
            return seconds;
        }

        let model = {
            consumerIds: this.interactonData.who.consumerIds.slice(),
            bulkId: this.interactonData.what.tag,
            scheduleTime: this.interactonData.when.date,
            specialDays: friendlyDisconnect.specialDays.map(x => x.date),
            weekdays: {
                disconnection_allowed: friendlyDisconnect.weekdays,
                earliest_time: friendlyDisconnect.weekdays ? getSecondsFromMidnight(friendlyDisconnect.weekdayStartTime) : 0,
                latest_time: friendlyDisconnect.weekdays ? getSecondsFromMidnight(friendlyDisconnect.weekdayEndTime) : 0
            },
            saturday: {
                disconnection_allowed: friendlyDisconnect.saturday,
                earliest_time: friendlyDisconnect.saturday ? getSecondsFromMidnight(friendlyDisconnect.saturdayStartTime) : 0,
                latest_time: friendlyDisconnect.saturday ? getSecondsFromMidnight(friendlyDisconnect.saturdayEndTime) : 0
            },
            sunday: {
                disconnection_allowed: friendlyDisconnect.sunday,
                earliest_time: friendlyDisconnect.sunday ? getSecondsFromMidnight(friendlyDisconnect.sundayStartTime) : 0,
                latest_time: friendlyDisconnect.sunday ? getSecondsFromMidnight(friendlyDisconnect.sundayEndTime) : 0
            }
        }

        friendlyDisconnectRequest = model;

        return friendlyDisconnectRequest;
    }

    formatTime24(data: string): string {
        // assuming hh:mm:ss 24 hour format to hh:mm pm/am
        if (!data) { return ""; }
        let timeType = "am"
        let timeParts = data.split(":");
        if (timeParts.length > 2) { timeParts.pop(); }

        if (Number(timeParts[0]) > 12 ||
            (Number(timeParts[0]) == 12 && Number(timeParts[1]) > 0)) {
            timeType = "pm"
        } else { timeType = "am" }

        let result = timeParts.join(":") + timeType;
        return result;
    }

    submit() {
        window.sessionStorage.removeItem("multi-device-interaction");
        swal({
            title: "Are you sure?",
            text: "You are about to send an interaction event, do you want to proceed",
            confirmButtonText: 'Yes please',
            confirmButtonColor: '#00539f',
            showCancelButton: true,
            cancelButtonText: "No, don't send",
            cancelButtonColor: '#00539f',
        }).then(val => {
            if (val.value == true) {
                this.sendInteractions();
            }
        });
    }

    abandonPopup() {
        window.sessionStorage.removeItem("multi-device-interaction");
        swal({
            title: "Are you sure?",
            text: "You are about to abandon the request, this will clear your progress, do you want to proceed?",
            confirmButtonText: 'Yes please',
            confirmButtonColor: '#00539f',
            showCancelButton: true,
            cancelButtonText: "No, don't abandon",
            cancelButtonColor: '#00539f',
        }).then(val => {
            if (val.value == true) {
                this.abandonRequest()
            }
        });
    }
}
